import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/builders-risk/projects',
    name: ROUTES.BUILDERS_RISK_PROJECTS,
    component: () => import('../views/builders-risk/BuildersRiskListView.vue'),
    children: [],
  },
  {
    path: '/:accountId/builders-risk/projects/:riskId',
    name: ROUTES.BUILDERS_RISK_PROJECT_VIEW,
    component: () => import('../views/builders-risk/BuildersRiskProjectView.vue'),
    children: [],
  },
  {
    path: '/:accountId/builders-risk/projects/:riskId/building/:buildingId',
    name: ROUTES.BUILDERS_RISK_BUILDING_VIEW,
    component: () => import('../views/builders-risk/BuildersRiskBuildingView.vue'),
  },
]
